import classNames from 'classnames';
import HorizontalContainerWrapper from 'pages/NewHome/HorizontalContainerWrapper';
import useStyles from './styles';

function DesignForUseCasesFallback() {
  const styles = useStyles({ titleColor: '' });
  return (
    <HorizontalContainerWrapper>
      <div className={styles.wrapperSkeleton}>
        <div className={styles.titleAndDescription}>
          <i className={classNames(styles.titleSkeleton, 'skeleton')} />
          <i className={classNames(styles.descriptionSkeleton, 'skeleton')} />
        </div>
        <div className={styles.content}>
          <div className={styles.labelSkeletonHolder}>
            <i className={classNames(styles.labelSkeleton, 'skeleton')} />
            <i className={classNames(styles.labelSkeleton, 'skeleton')} />
            <i className={classNames(styles.labelSkeleton, 'skeleton')} />
          </div>
          <div className={styles.imageHolder}>
            <i className={classNames(styles.visibleImage, 'skeleton')} />
          </div>
        </div>
      </div>
    </HorizontalContainerWrapper>
  );
}

export default DesignForUseCasesFallback;
